export class OrganizationLink
{
    CategoryIds: number[] = [];
    Id!: number;
    Name!: string;
    OrganizationId!: number;
    Url!: string;

    constructor(json?: any)
    {
        if (json)
        {
            Object.assign(this, json);
        }
    }
}
